import { Component, input } from '@angular/core'

import { ExecutionPlanAction } from '@flowx/designer/modules/ai/common/api/conversation-api.types'

@Component({
  selector: 'flx-ai-msg-action-card',
  templateUrl: './ai-chat-msg-action-card.component.html',
})
export class AiChatMsgActionCardComponent {
  action = input.required<ExecutionPlanAction>()
}
